import { PRODUCT_PERIODS_DATES } from '../../../../../../../fields'

export const isProductValid = productValues => {
  const isInventoryLoading = productValues.isInventoryLoading
  const selectedPeriods = productValues[PRODUCT_PERIODS_DATES]

  const hasSelectedPeriods = selectedPeriods && selectedPeriods.length > 0

  return !isInventoryLoading && hasSelectedPeriods
}
